export const eventsSearchPath = '/for-abiturients/events'

export const templatesID = {
  6085: '10062',
  7009: '10085',
  7050: '10085',
  7049: '10085',
  7047: '10085',
  7490: '10090',
  7588: '10099',
  9944: '10108',
  11471: '10126',
}
